import React, { useState, useEffect } from 'react';
import api from '../../utils/api';

function Contacto() {
  const [contacto, setContacto] = useState(null);

  useEffect(() => {
    api.get(`contacto/`)
      .then(response => {
        setContacto(response.data);
      })
      .catch(error => console.error('Error fetching contacto:', error));
  }, []);

  if (!contacto) {
    return (
      <div className="page">
        <h1>Contacto</h1>
        <p>Cargando información de contacto...</p>
      </div>
    );
  }

  return (
    <div className="page">
      <h1>Contacto</h1>
      <p>
        Dirección: {contacto.direccion}<br />
        Teléfono: {contacto.telefono}<br />
        Email: {contacto.email}<br />
        <a href={contacto.google_maps_link} target="_blank" rel="noopener noreferrer">
          Ver en Google Maps
        </a>
      </p>
      <div className="map-container">
        <iframe
          title="Ubicación Club Nexo"
          src={contacto.google_maps_embed}
          width="100%"
          height="400"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div>
    </div>
  );
}

export default Contacto;